import React from 'react';

import { uiHelpers } from '../../helpers';
import { ReactTable } from '../../types';

export enum DateType {
  utc = 'utc',
  local = 'local',
}

const DateTimeCell: React.FC<{
  cell: ReactTable.Cell;
  dateType?: DateType;
}> = ({ cell: { value }, dateType }) => {
  return (
    <span>
      {dateType === DateType.local
        ? uiHelpers.formatDateTimeLocal(value)
        : uiHelpers.formatDateTime(value)}
    </span>
  );
};

export default DateTimeCell;
